export default __webpack_public_path__ + "static/media/UseEffectMemoryLeak.8b5f9deb.md";